import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=4950a3b6&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=4950a3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4950a3b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4950a3b6')) {
      api.createRecord('4950a3b6', component.options)
    } else {
      api.reload('4950a3b6', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=4950a3b6&scoped=true&", function () {
      api.rerender('4950a3b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uL3rAjmWEnP2/JS/comp/PopupDialog.vue"
export default component.exports